import ODAS from '@/utils/api/odas';

const Resources = {
  getUtilizationByResources: async (resourceIds) => {
    if (!resourceIds) {
      return {};
    }
    return ODAS.get('/api/opportunities/utilization', { resources: resourceIds.join() });
  },
  getUtilizationByResource: async (resourceId) => {
    if (!resourceId) return {};
    return ODAS.get('/api/opportunities/utilization', { resource: resourceId });
  }
};

export default Resources;
